import Marquee from "react-fast-marquee";

const data = [
  "1.png",
  "2.png",
  "3.png",
  "4.png",
  "5.png",
  "6.png",
  "7.png",
  "8.jpeg",
  "9.webp",
  "10.png",
  "11.webp",
  "12.jpg",
  "13.avif",
  "14.png",
  "15.png",
  "16.png",
  "17.png",
  "18.png",
  "19.jpg",
  "20.png",
  "21.jpg",
  "22.png",
  "23.png",
  "24.jpg",
  "25.png",
];

const data2 = [
  "26.jpg",
  "27.png",
  "28.jpg",
  "29.png",
  "30.png",
  "31.png",
  "32.png",
  "33.png",
  "34.png",
  "35.webp",
  "36.png",
  "37.jpg",
  "38.png",
  "39.jpg",
  "40.svg",
  "41.jpg",
  "42.png",
  "43.png",
  "44.jpg",
  "45.png",
  "46.jpg",
  "47.png",
  "48.jpg",
  "48.png",
  "49.png",
];

const data3 = [
  "50.jpg",
  "51.jpg",
  "52.png",
  "53.jpg",
  "54.png",
  "55.jpg",
  "56.png",
  "57.png",
  "58.png",
  "59.jpg",
  "60.jpg",
  "61.png",
  "62.jpeg",
  "63.webp",
  "64.png",
  "65.png",
  "66.png",
  "67.png",
  "68.png",
  "69.png",
  "70.jpg",
  "70.png",
  "71.jpg",
  "72.jpg",
  "73.png",
  "74.webp",
];

const KYouthPartners = () => {
  return (
    <div className="edu-intructor-area edu-section-gap-k-youth-partners bg-color-white">
      <div className="row g-5">
        <div className="col-lg-12">
          <div className="section-title text-center">
            <span className="pre-title">Our Partners</span>
            <h3 className="title">Strategic Partners</h3>
          </div>
        </div>
      </div>
      <div className="row g-5 mt--20">
        <Marquee speed={100}>
          {data.map((asset, index) => (
            <img
              src={`${process.env.PUBLIC_URL}/k-youth/assets/logo/${asset}`}
              style={{
                height: 100,
                width: 200,
                objectFit: "contain",
                paddingLeft: 20,
                paddingRight: 20,
              }}
            />
          ))}
        </Marquee>
        <Marquee speed={100} direction="right">
          {data2.map((asset, index) => (
            <img
              src={`${process.env.PUBLIC_URL}/k-youth/assets/logo/${asset}`}
              style={{
                height: 100,
                width: 200,
                objectFit: "contain",
                paddingLeft: 20,
                paddingRight: 20,
              }}
            />
          ))}
        </Marquee>
        <Marquee speed={100}>
          {data3.map((asset, index) => (
            <img
              src={`${process.env.PUBLIC_URL}/k-youth/assets/logo/${asset}`}
              style={{
                height: 100,
                width: 200,
                objectFit: "contain",
                paddingLeft: 20,
                paddingRight: 20,
              }}
            />
          ))}
        </Marquee>
        {/* {data.map((partner, i) => (
            <KYouthPartner partnerLogo={i} />
          ))} */}
      </div>
    </div>
  );
};

export default KYouthPartners;
